<div class="hb-container hb-container--width-lg">
  <!--  Legger til &shy; for word-break på 400% zoom, ihht UU-->
  <h1 class="hb-h1 hb-text--3xl hb-avstand--avsnitt">Begreps&shy;forklaringer</h1>

  <div class="hb-fieldset">
    <div class="hb-legend">
      <div class="hb-legend-tekst" aria-hidden="true">Vis begreper for:</div>
    </div>

    <fieldset class="hb-felt">
      <legend class="hb-screenreader-only">Vis begreper for:</legend>

      <div class="hb-buttongroup hb-mb--md">
        <input name="begreperRadio" class="hb-radiobutton" id="begreper-bostotte" type="radio" value="bostotte" (change)="onBegrepChange(1)" [checked]="begrepskode === 1" />
        <label class="hb-button hb-button--standard" for="begreper-bostotte">Bostøtte</label>

        <input name="begreperRadio" class="hb-radiobutton" id="begreper-startlan" type="radio" value="startlan" (change)="onBegrepChange(2)" [checked]="begrepskode === 2" />
        <label class="hb-button hb-button--standard" for="begreper-startlan">Startlån</label>

        <input
          name="begreperRadio"
          class="hb-radiobutton"
          id="begreper-boligkvalitet"
          type="radio"
          value="boligkvalitet"
          (change)="onBegrepChange(4)"
          [checked]="begrepskode === 4"
        />
        <label class="hb-button hb-button--standard" for="begreper-boligkvalitet">Lån til boligkvalitet</label>

        <input name="begreperRadio" class="hb-radiobutton" id="begreper-grunnlan" type="radio" value="grunnlan" (change)="onBegrepChange(3)" [checked]="begrepskode === 3" />
        <label class="hb-button hb-button--standard" for="begreper-grunnlan">Grunnlån (Historisk ordning)</label>

        <input name="begreperRadio" class="hb-radiobutton" id="begreper-barnehage" type="radio" value="barnehage" (change)="onBegrepChange(5)" [checked]="begrepskode === 5" />
        <label class="hb-button hb-button--standard" for="begreper-barnehage">Lån til barnehager (Historisk ordning)</label>
      </div>

      <div class="hb-buttongroup">
        <input
          name="begreperRadio"
          class="hb-radiobutton"
          id="begreper-studentbolig"
          type="radio"
          value="studentbolig"
          (change)="onBegrepChange(6)"
          [checked]="begrepskode === 6"
        />
        <label class="hb-button hb-button--standard" for="begreper-studentbolig">Lån til studentboliger</label>

        <input name="begreperRadio" class="hb-radiobutton" id="begreper-utleiebolig" type="radio" value="utleiebolig" (change)="onBegrepChange(7)" [checked]="begrepskode === 7" />
        <label class="hb-button hb-button--standard" for="begreper-utleiebolig">Lån til utleiebolig</label>

        <input name="begreperRadio" class="hb-radiobutton" id="begreper-tilskudd" type="radio" value="tilskudd" (change)="onBegrepChange(8)" [checked]="begrepskode === 8" />
        <label class="hb-button hb-button--standard" for="begreper-tilskudd">Tilskudd til utleiebolig</label>

        <input name="begreperRadio" class="hb-radiobutton" id="begreper-invtilskudd" type="radio" value="invtilskudd" (change)="onBegrepChange(9)" [checked]="begrepskode === 9" />
        <label class="hb-button hb-button--standard" for="begreper-invtilskudd">Investeringstilskudd</label>

        <input name="begreperRadio" class="hb-radiobutton" id="begreper-enetilskudd" type="radio" value="enetilskudd" (change)="onBegrepChange(9)" [checked]="begrepskode === 9" />
        <label class="hb-button hb-button--standard" for="begreper-enetilskudd">Energitilskudd</label>
      </div>
    </fieldset>
  </div>

  <div class="hb-scrollbox">
    @if (begrepskode === 1) {
      <table class="hb-table-simple begrepstabell">
        <thead>
          <tr>
            <th>Begrep</th>
            <th>Forklaring Bostøtte</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Antall husstander</td>
            <td>Antall husstander som faller innenfor det gitte søkekriteriet.</td>
          </tr>
          <tr>
            <td>Antall husstandsmedlemmer</td>
            <td>Personer som faktisk bor i boligen, samt personer som er folkeregistrert bosatt på adressen.</td>
          </tr>
          <tr>
            <td>Aldersgruppe</td>
            <td>Hovedmottaker gruppert etter alder.</td>
          </tr>
          <tr>
            <td>Avslag</td>
            <td>
              Negativt svar på søknaden om bostøtte for en gitt periode (termin). Vedtaket kan påklages, men utbetalt bostøtte som følge av klager og etterbehandling er ikke
              inkludert i denne statistikken.
            </td>
          </tr>
          <tr>
            <td>Avslagsårsak</td>
            <td>Avslag kategorisert etter begrunnelse.</td>
          </tr>
          <tr>
            <td>Barnefamilie</td>
            <td>Husstand med barn under 18 år i familien.</td>
          </tr>
          <tr>
            <td>Brukergruppe</td>
            <td>
              Deler husstanden inn i følgende grupper basert på inntektskilde:
              <ul>
                <li>Unge uføre</li>
                <li>Uføre for øvrig</li>
                <li>Eldre</li>
                <li>Husstander med midlertidige trygdeytelser</li>
                <li>Husstander uten trygdeytelser</li>
              </ul>
            </td>
          </tr>
          <tr>
            <td>Boutgift over tak</td>
            <td>Boutgifter som overstiger øvre grense for boutgift, jf. Forskrift om bostøtte § 3.</td>
          </tr>
          <tr>
            <td>Elektroniske søknader</td>
            <td>Opplysninger fra søker på elektronisk form, i motsetning til søknad på papir. Søker har benyttet seg av Husbankens elektroniske søknadsløsning.</td>
          </tr>
          <tr>
            <td>Eierforhold</td>
            <td>
              Beskriver boligsituasjonen til husstanden etter eie eller leiesituasjon:
              <ul>
                <li>Eie: Selveier eller sameie</li>
                <li>Borettslag med videre: Borettslag, aksjeleilighet eller obligasjonsleilighet</li>
                <li>Leie: privat eller kommunal leiebolig</li>
              </ul>
            </td>
          </tr>
          <tr>
            <td>Gjennomsnittlig inntekt</td>
            <td>
              Gjennomsnittlig årlig inntekt for husstandene innenfor det gitte søkekriteriet. Inntekten er samlet årlig inntekt (personinntekt og allmenninntekt med tillegg av et
              beløp som svarer til minstefradraget) for alle husstandsmedlemmer inkl. ev. tillegg for formue, jf. Forskrift om bostøtte. Barns inntekt er ikke inkludert. Bostøtten
              benytter seg av månedlig inntekt, som multipliseres med 12 siden satsene i bostøtteregelverket er på årsnivå.
            </td>
          </tr>

          <tr>
            <td>Gjennomsnittlig boutgift</td>
            <td>
              Gjennomsnittlig årlige boutgifter for husstandene innenfor det gitte søkekriteriet. Boutgift er summen av ulike utgifter pr. år, som godkjennes iht forskrift om
              bostøtte.
            </td>
          </tr>
          <tr>
            <td>Søknad</td>
            <td>Viser søknader om bostøtte for en gitt termin. Uavhengig av vedtaksutfall.</td>
          </tr>
          <tr>
            <td>Terminutbetaling</td>
            <td>Datovalg som gir deg observasjoner basert på terminen utbetalingen gjelder for. Bostøtten utbetales den 20. i måneden etter søknadsterminen.</td>
          </tr>
          <tr>
            <td>Utbetaling</td>
            <td>Datovalg som gir deg observasjoner basert dato for utbetalingen. Bostøtten utbetales den 20. i måneden etter søknadsterminen.</td>
          </tr>
          <tr>
            <td>Utbetalt beløp</td>
            <td>Hvor mye bostøtte som er utbetalte innenfor det gitte søkekriteriet. Viser ikke utbetalinger i forbindelse med klager og etterbehandling.</td>
          </tr>
        </tbody>
      </table>
    }
  </div>

  @if (begrepskode === 2) {
    <table class="hb-table-simple begrepstabell">
      <thead>
        <tr>
          <th>Begrep</th>
          <th>Forklaring Startlån</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Antall husstander</td>
          <td>Antall husstander som faller innenfor det gitte søkekriteriet. Én husstand kan ha sendt inn flere søknader, i ulike kommuner og over flere perioder.</td>
        </tr>
        <tr>
          <td>Antall søknader</td>
          <td>Antall søknader innenfor valgte tidsperiode. En husstand kan ha sendt flere søknader til en kommune og / eller til flere kommuner.</td>
        </tr>
        <tr>
          <td>Antall søknader med avslag</td>
          <td>
            Antall søknader hvor det siste vedtaket innenfor valgt tidsperiode er avslag. En søknad kan få nytt vedtak i en senere tidsperiode. Saken vil da telle i begge perioder.
          </td>
        </tr>
        <tr>
          <td>Avslagsprosent for søknader</td>
          <td>Avslagsprosenteten beregnet av antall søknader hvor siste vedtak er avslag.</td>
        </tr>

        <tr>
          <td>Antall vedtak</td>
          <td>Summen av alle vedtak fattet på søknadene. En søknad kan ha flere vedtak.</td>
        </tr>
        <tr>
          <td>Antall vedtak med avslag</td>
          <td>Summen av alle vedtak fattet hvor utfallet har vært avslag. En søknad kan ha flere vedtak.</td>
        </tr>
        <tr>
          <td>Avslagsprosent for vedtak</td>
          <td>Avslagsprosenteten beregnet av alle vedtak hvor utfallet har vært avslag,</td>
        </tr>
        <tr>
          <td>Avslagsårsak</td>
          <td>Avslag kategorisert etter begrunnelse.</td>
        </tr>
        <tr>
          <td>Aldersgruppe</td>
          <td>Hovedmottaker gruppert etter alder.</td>
        </tr>
        <tr>
          <td>Andel startlån av kjøpesum</td>
          <td>
            Kjøpesum er avtalt beløp mellom selger og kjøper. Sum startlån utgjør en andel av kjøpesummen. For andre formålstyper gjelder det andelen av det totale
            finansieringsbehovet.
          </td>
        </tr>
        <tr>
          <td>Barnefamilie</td>
          <td>Husstand med barn under 18 år i familien.</td>
        </tr>
        <tr>
          <td>Beløp startlån</td>
          <td>Samlet utbetalt startlån fra kommunene, innenfor det gitte søkekriteriet.</td>
        </tr>
        <tr>
          <td>Søkt beløp</td>
          <td>Totalt søkt beløp for alle søknader innenfor det gitte søkekriteriet. Gjelder kun søknader der det er oppgitt et konkret beløp.</td>
        </tr>
        <tr>
          <td>Søknad</td>
          <td>Informasjon om søknader kommunene har mottatt etter når søknaden ble sendt inn.</td>
        </tr>
        <tr>
          <td>Tiltak</td>
          <td>Hva startlånet skal finansiere, f.eks. kjøp av bolig eller refinansiering.</td>
        </tr>
        <tr>
          <td>Tidligere boforhold</td>
          <td>Husstandens boforhold på søknadstidspunktet.</td>
        </tr>
        <tr>
          <td>Samfinansiering</td>
          <td>Finansieringsbehovet er dekket av startlån og lån i ordinær bank.</td>
        </tr>
        <tr>
          <td>Fullfinansiering</td>
          <td>Finansieringsbehovet er fullfinansiert av startlån.</td>
        </tr>
      </tbody>
    </table>
  }

  @if (begrepskode === 3) {
    <table class="hb-table-simple begrepstabell">
      <thead>
        <tr>
          <th>Begrep</th>
          <th>Forklaring Grunnlån (Historisk ordning)</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Antall boliger</td>
          <td>Antall boliger som er ført opp på søknaden, knyttet til tilsagnet eller knyttet til utbetalingen. Tallet vises for det gitte søkekriteriet.</td>
        </tr>
        <tr>
          <td>Antall saker</td>
          <td>Antall saker som faller innenfor det gitte søkekriteriet.</td>
        </tr>
        <tr>
          <td>Antall søknader</td>
          <td>Antall søknader om grunnlån innenfor gitte søkekriterier.</td>
        </tr>
        <tr>
          <td>Beløp</td>
          <td>Sum søkt beløp, sum tilsagnsbeløp eller sum utbetalt beløp av grunnlån for valgte kriterier.</td>
        </tr>
        <tr>
          <td>Boligformål</td>
          <td>
            En inndeling av hva boligene som får tilskudd skal brukes til:
            <ul>
              <li>Boligsosialt: boliger til bostedsløse, boligsosialt, enslige mindreårlige flyktninger, flyktninger, nedsatt funksjonsevne, andre vanskeligstilte</li>
              <li>Boligkvalitet: kvalitet</li>
              <li>Utleiebolig: utleiebolig, utleieboliger med kommunal tilvisningsrett</li>
              <li>Studentbolig</li>
              <li>Ordinær boligforsyning</li>
              <li>Ikke registrert</li>
            </ul>
          </td>
        </tr>
        <tr>
          <td>Kvalitetskrav</td>
          <td>
            Kategori for ulike typer kvaliteter forbundet med universell utforming og energi og miljø på boliger, basert på Husbankens regelverk for grunnlån. Dispensasjon kan gis
            på grunn av distriktshensyn, eller fra krav om miljø/energi eller til boligsosiale formål.
          </td>
        </tr>
        <tr>
          <td>Prosjektkostnad</td>
          <td>
            Summen av samtlige kostnader for prosjektet. I prosjektkostnadene inngår:
            <ul>
              <li>felleskostnader</li>
              <li>bygning</li>
              <li>VVS-installasjoner</li>
              <li>elkraftinstallasjoner</li>
              <li>tele- og automatiseringsinstallasjoner</li>
              <li>andre installasjoner</li>
              <li>utendørs arbeid</li>
              <li>generelle kostnader</li>
              <li>spesielle kostnader</li>
              <li>eventuelle marginer og reserver</li>
            </ul>
            Gjennomsnittlig prosjektkostnad beregnes slik: sum prosjektkostnader pr valgt år eller måned, delt på antall prosjekter i valgt år eller måned.
          </td>
        </tr>
        <tr>
          <td>Søkertype</td>
          <td>Søkere inndelt i kategorier. Kategoriene er basert på organisasjonsform.</td>
        </tr>
        <tr>
          <td>Tilsagn</td>
          <td>Tilsagn er et løfte om penger mot at søker oppfyller visse betingelser. Et tilsagn kan ha flere boliger. Det kan være flere tilsagn på en sak.</td>
        </tr>
        <tr>
          <td>Tiltak</td>
          <td>
            Hva grunnlånet skal brukes til, f.eks. kjøp, oppføring eller oppgradering. Kan være små differanser med det Husbanken rapporterer på i årsrapporter (oppføring,
            oppgradering og kjøp av utleieboliger) som baserer seg på en inndeling i saksbehandlingen til Husbanken.
          </td>
        </tr>
        <tr>
          <td>Tilvisningsavtale</td>
          <td>
            Prosjekter der det i Husbankens systemer er registerert at kommunen har avtale om tilvisningsrett til alle eller en andel av utleieboligene i prosjektet.<br /><br />
            Husbanken teller boliger i prosjekter med tilvisningsavtale som følger:
            <ul>
              <li>Antall boliger: Viser antall boliger totalt i prosjektet.</li>
              <li>Antall boliger med kommunal tilvisningsrett: Viser antall boliger i prosjektet som kommunen har tilvisningsrett på.</li>
            </ul>
            Dersom prosjektet har fem eller færre boliger telles alle boligene i prosjektet. Dersom det er over fem boliger i prosjektet telles 40% av disse.
          </td>
        </tr>
        <tr>
          <td>Utbetalinger</td>
          <td>Statistikk for utbetalte lån innenfor gitte søkekriterier. Lånet utbetales når prosjektet er ferdigstilt og tatt i bruk.</td>
        </tr>
      </tbody>
    </table>
  }

  @if (begrepskode === 4) {
    <table class="hb-table-simple begrepstabell">
      <thead>
        <tr>
          <th>Begrep</th>
          <th>Forklaring Lån til boligkvalitet</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Antall boliger</td>
          <td>Antall boliger som er ført opp på søknaden, knyttet til tilsagnet eller knyttet til utbetalingen. Tallet vises for det gitte søkekriteriet.</td>
        </tr>
        <tr>
          <td>Antall saker</td>
          <td>Antall saker som faller innenfor det gitte søkekriteriet.</td>
        </tr>
        <tr>
          <td>Antall søknader</td>
          <td>Antall søknader om lån til boligkvalitet innenfor gitte søkekriterier.</td>
        </tr>
        <tr>
          <td>Beløp</td>
          <td>Sum søkt beløp, sum tilsagnsbeløp eller sum utbetalt beløp av lån for valgte kriterier.</td>
        </tr>
        <tr>
          <td>Formål</td>
          <td>
            En inndeling av boligene som får lån og hva det skal brukes til:
            <ul>
              <li>Oppføring av livsløpsbolig</li>
              <li>Oppføring av miljøvennlige boliger</li>
              <li>Oppgradering av bolig</li>
            </ul>
          </td>
        </tr>
        <tr>
          <td>Prosjektkostnad</td>
          <td>
            Summen av samtlige kostnader for prosjektet. I prosjektkostnadene inngår:
            <ul>
              <li>felleskostnader</li>
              <li>bygning</li>
              <li>VVS-installasjoner</li>
              <li>elkraftinstallasjoner</li>
              <li>tele- og automatiseringsinstallasjoner</li>
              <li>andre installasjoner</li>
              <li>utendørs arbeid</li>
              <li>generelle kostnader</li>
              <li>spesielle kostnader</li>
              <li>eventuelle marginer og reserver</li>
            </ul>
            Gjennomsnittlig prosjektkostnad beregnes slik: sum prosjektkostnader pr valgt år eller måned, delt på antall prosjekter i valgt år eller måned.
          </td>
        </tr>
        <tr>
          <td>Søkertype</td>
          <td>Søkere inndelt i kategorier. Kategoriene er basert på organisasjonsform.</td>
        </tr>
        <tr>
          <td>Tilsagn</td>
          <td>Tilsagn er et løfte om penger mot at søker oppfyller visse betingelser. Et tilsagn kan ha flere boliger. Det kan være flere tilsagn på en sak.</td>
        </tr>
        <tr>
          <td>Tiltak</td>
          <td>Hva lån til boligkvalitet skal brukes til, f.eks. oppføring, kjøp eller ombygging.</td>
        </tr>
        <tr>
          <td>Utbetalinger</td>
          <td>Statistikk for utbetalte lån innenfor gitte søkekriterier. Lånet utbetales når prosjektet er ferdigstilt og tatt i bruk.</td>
        </tr>
      </tbody>
    </table>
  }

  @if (begrepskode === 5) {
    <table class="hb-table-simple begrepstabell">
      <thead>
        <tr>
          <th>Begrep</th>
          <th>Forklaring Lån til barnehager (Historisk ordning)</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Antall barnehageplasser</td>
          <td>Antall barnehageplasser som er ført opp på søknaden, knyttet til tilsagnet eller knyttet til utbetalingen.</td>
        </tr>
        <tr>
          <td>Antall saker</td>
          <td>Antall saker som faller innenfor det gitte søkekriteriet.</td>
        </tr>
        <tr>
          <td>Antall søknader</td>
          <td>Antall søknader om lån til barnehager innenfor gitte søkekriterier.</td>
        </tr>
        <tr>
          <td>Beløp</td>
          <td>Sum søkt beløp, sum tilsagnsbeløp eller sum utbetalt beløp av lån for valgte kriterier.</td>
        </tr>
        <tr>
          <td>Prosjektkostnad</td>
          <td>
            Summen av samtlige kostnader for prosjektet. I prosjektkostnadene inngår:
            <ul>
              <li>felleskostnader</li>
              <li>bygning</li>
              <li>VVS-installasjoner</li>
              <li>elkraftinstallasjoner</li>
              <li>tele- og automatiseringsinstallasjoner</li>
              <li>andre installasjoner</li>
              <li>utendørs arbeid</li>
              <li>generelle kostnader</li>
              <li>spesielle kostnader</li>
              <li>eventuelle marginer og reserver</li>
            </ul>
            Gjennomsnittlig prosjektkostnad per barnehageplass beregnes slik: sum prosjektkostnader pr valgt år eller måned, delt på antall prosjekter i valgt år eller måned, delt
            på antall barnehageplasser.
          </td>
        </tr>
        <tr>
          <td>Søkertype</td>
          <td>Søkere inndelt i kategorier. Kategoriene er basert på organisasjonsform.</td>
        </tr>
        <tr>
          <td>Tilsagn</td>
          <td>Tilsagn er et løfte om penger mot at søker oppfyller visse betingelser. Et tilsagn kan ha flere boliger. Det kan være flere tilsagn på en sak.</td>
        </tr>
        <tr>
          <td>Tiltak</td>
          <td>Hva lån til barnehage skal brukes til, f.eks. kjøp, oppføring eller ombygging.</td>
        </tr>
        <tr>
          <td>Utbetalinger</td>
          <td>Statistikk for utbetalte lån innenfor gitte søkekriterier. Lånet utbetales når prosjektet er ferdigstilt og tatt i bruk.</td>
        </tr>
      </tbody>
    </table>
  }

  @if (begrepskode === 6) {
    <table class="hb-table-simple begrepstabell">
      <thead>
        <tr>
          <th>Begrep</th>
          <th>Forklaring Lån til studentboliger</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Antall boliger</td>
          <td>Antall boliger som er ført opp på søknaden, knyttet til tilsagnet eller knyttet til utbetalingen. Tallet vises for det gitte søkekriteriet.</td>
        </tr>
        <tr>
          <td>Antall saker</td>
          <td>Antall saker som faller innenfor det gitte søkekriteriet.</td>
        </tr>
        <tr>
          <td>Antall søknader</td>
          <td>Antall søknader om lån til studentboliger innenfor gitte søkekriterier.</td>
        </tr>
        <tr>
          <td>Beløp</td>
          <td>Sum søkt beløp, sum tilsagnsbeløp eller sum utbetalt beløp av lån for valgte kriterier.</td>
        </tr>
        <tr>
          <td>Prosjektkostnad</td>
          <td>
            Summen av samtlige kostnader for prosjektet. I prosjektkostnadene inngår:
            <ul>
              <li>felleskostnader</li>
              <li>bygning</li>
              <li>VVS-installasjoner</li>
              <li>elkraftinstallasjoner</li>
              <li>tele- og automatiseringsinstallasjoner</li>
              <li>andre installasjoner</li>
              <li>utendørs arbeid</li>
              <li>generelle kostnader</li>
              <li>spesielle kostnader</li>
              <li>eventuelle marginer og reserver</li>
            </ul>
            Gjennomsnittlig prosjektkostnad beregnes slik: sum prosjektkostnader pr valgt år eller måned, delt på antall prosjekter i valgt år eller måned.
          </td>
        </tr>
        <tr>
          <td>Søkertype</td>
          <td>Søkere inndelt i kategorier. Kategoriene er basert på organisasjonsform.</td>
        </tr>
        <tr>
          <td>Tilsagn</td>
          <td>Tilsagn er et løfte om penger mot at søker oppfyller visse betingelser. Et tilsagn kan ha flere boliger. Det kan være flere tilsagn på en sak.</td>
        </tr>
        <tr>
          <td>Tiltak</td>
          <td>Hva lån til studentbolig skal brukes til, f.eks. oppføring, kjøp eller ombygging.</td>
        </tr>
        <tr>
          <td>Utbetalinger</td>
          <td>Statistikk for utbetalte lån innenfor gitte søkekriterier. Lånet utbetales når prosjektet er ferdigstilt og tatt i bruk.</td>
        </tr>
      </tbody>
    </table>
  }

  @if (begrepskode === 7) {
    <table class="hb-table-simple begrepstabell">
      <thead>
        <tr>
          <th>Begrep</th>
          <th>Forklaring Lån til utleieboliger</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Antall boliger</td>
          <td>Antall boliger som er ført opp på søknaden, knyttet til tilsagnet eller knyttet til utbetalingen. Tallet vises for det gitte søkekriteriet.</td>
        </tr>
        <tr>
          <td>Antall saker</td>
          <td>Antall saker som faller innenfor det gitte søkekriteriet.</td>
        </tr>
        <tr>
          <td>Antall søknader</td>
          <td>Antall søknader om lån til utleieboliger innenfor gitte søkekriterier.</td>
        </tr>
        <tr>
          <td>Beløp</td>
          <td>Sum søkt beløp, sum tilsagnsbeløp eller sum utbetalt beløp av lån for valgte kriterier.</td>
        </tr>
        <tr>
          <td>Prosjektkostnad</td>
          <td>
            Summen av samtlige kostnader for prosjektet. I prosjektkostnadene inngår:
            <ul>
              <li>felleskostnader</li>
              <li>bygning</li>
              <li>VVS-installasjoner</li>
              <li>elkraftinstallasjoner</li>
              <li>tele- og automatiseringsinstallasjoner</li>
              <li>andre installasjoner</li>
              <li>utendørs arbeid</li>
              <li>generelle kostnader</li>
              <li>spesielle kostnader</li>
              <li>eventuelle marginer og reserver</li>
            </ul>
            Gjennomsnittlig prosjektkostnad beregnes slik: sum prosjektkostnader pr valgt år eller måned, delt på antall prosjekter i valgt år eller måned.
          </td>
        </tr>
        <tr>
          <td>Søkertype</td>
          <td>Søkere inndelt i kategorier. Kategoriene er basert på organisasjonsform.</td>
        </tr>
        <tr>
          <td>Tilsagn</td>
          <td>Tilsagn er et løfte om penger mot at søker oppfyller visse betingelser. Et tilsagn kan ha flere boliger. Det kan være flere tilsagn på en sak.</td>
        </tr>
        <tr>
          <td>Tiltak</td>
          <td>Hva lån til utleiebolig skal brukes til, f.eks. oppføring, kjøp eller ombygging.</td>
        </tr>
        <tr>
          <td>Tilvisningsavtale</td>
          <td>
            Prosjekter der det i Husbankens systemer er registrert at kommune har avtale om tilvisningsrett til alle eller en andel av utleieboligene i prosjektet. Private aktører
            som har avtale med kommunen kan enten ha;
            <ol>
              <li>Tildelingsavtale med kommunen, som sier at kommunen har disposisjonsrett på alle boligene i prosjektet. Disse kan også ha tilskudd til utleieboliger.</li>
              <li>Tilvisningsavtale med kommunen, som sier at kommunen har disposisjonsrett på en andel av boligene i prosjektet. Disse kan ikke ha tilskudd til utleieboliger.</li>
            </ol>
            Husbanken teller boliger i prosjektet med tilvisningsavtaler som følger;
            <ul>
              <li>Antall boliger; Viser antall boliger totalt i prosjektet.</li>
              <li>Antall boliger med kommunal tilvisningsrett.</li>
            </ul>
          </td>
        </tr>
        <tr>
          <td>Utbetalinger</td>
          <td>Statistikk for utbetalte lån innenfor gitte søkekriterier. Lånet utbetales når prosjektet er ferdigstilt og tatt i bruk.</td>
        </tr>
      </tbody>
    </table>
  }

  @if (begrepskode === 8) {
    <table class="hb-table-simple begrepstabell">
      <thead>
        <tr>
          <th>Begrep</th>
          <th>Forklaring Tilskudd til utleiebolig</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Antall boliger</td>
          <td>Antall boliger som er ført opp på søknaden, knyttet til tilsagnet eller knyttet til utbetalingen. Tallet vises for det gitte søkekriteriet.</td>
        </tr>
        <tr>
          <td>Antall saker</td>
          <td>Antall saker som faller innenfor det gitte søkekriteriet.</td>
        </tr>
        <tr>
          <td>Antall søknader</td>
          <td>Antall søknader om tilskudd til utleiebolig innenfor gitte søkekriterier.</td>
        </tr>
        <tr>
          <td>Beløp</td>
          <td>Sum søkt beløp, sum tilsagnsbeløp eller sum utbetalt beløp av tilskudd for valgte kriterier.</td>
        </tr>
        <tr>
          <td>Prosjektkostnad</td>
          <td>
            Summen av samtlige kostnader for prosjektet. I prosjektkostnadene inngår:
            <ul>
              <li>felleskostnader</li>
              <li>bygning</li>
              <li>VVS-installasjoner</li>
              <li>elkraftinstallasjoner</li>
              <li>tele- og automatiseringsinstallasjoner</li>
              <li>andre installasjoner</li>
              <li>utendørs arbeid</li>
              <li>generelle kostnader</li>
              <li>spesielle kostnader</li>
              <li>eventuelle marginer og reserver</li>
            </ul>
            Gjennomsnittlig prosjektkostnad beregnes slik: sum prosjektkostnader pr valgt år eller måned, delt på antall prosjekter i valgt år eller måned.
          </td>
        </tr>
        <tr>
          <td>Søkertype</td>
          <td>Søkere inndelt i kategorier. Kategoriene er basert på organisasjonsform.</td>
        </tr>
        <tr>
          <td>Tilsagn</td>
          <td>
            Tilsagn er et løfte om penger mot at søker oppfyller visse betingelser. Et tilsagn kan ha flere boliger. Det kan være flere tilsagn på en sak. Viser statistikk om dette
            innenfor gitte søkekriterier.
          </td>
        </tr>
        <tr>
          <td>Tiltak</td>
          <td>
            Hva tilskuddet skal brukes til, f.eks. kjøp, oppføring eller oppgradering. Kan være små differanser med det Husbanken rapporterer på i årsrapporter (oppføring,
            oppgradering og kjøp av utleieboliger) som baserer seg på en inndeling i saksbehandlingen til Husbanken.
          </td>
        </tr>
        <tr>
          <td>Utbetalinger</td>
          <td>Statistikk for utbetalte tilskudd innenfor gitte søkekriterier. Tilskuddet utbetales når prosjektet er ferdigstilt og tatt i bruk.</td>
        </tr>
      </tbody>
    </table>
  }

  @if (begrepskode === 9) {
    <table class="hb-table-simple begrepstabell">
      <thead>
        <tr>
          <th>Begrep</th>
          <th>Forklaring Investeringstilskudd</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Antall omsorgsplasser</td>
          <td>
            Viser det totale antall omsorgsplasser som er omfattet av tilskuddet (sykehjemsplasser + omsorgsboliger) innenfor gitte søkekriterier. Saker som kun omfatter
            dagaktivitetssentre eller heving av teknisk standard oppgir ikke noen plasser her.
          </td>
        </tr>
        <tr>
          <td>Antall omsorgsboliger</td>
          <td>Viser det totale antall omsorgsboliger som er omfattet av tilskuddet innenfor gitte søkekriterier.</td>
        </tr>
        <tr>
          <td>Antall sykehjemsplasser</td>
          <td>Viser det totale antall sykehjemsplasser som er omfattet av tilskuddet innenfor gitte søkekriterier.</td>
        </tr>
        <tr>
          <td>Beløp</td>
          <td>Sum som søker spør om i forespørsel, oppgir i søknad, får i tilsagn eller utbetalt.</td>
        </tr>
        <tr>
          <td>Fellesareal</td>
          <td>
            Det kan gis tilskudd til fellesareal i tilknytning til eksisterende omsorgsboliger for å oppnå heldøgnstjeneste. Tallet i rapporten angir sum av kvadratmeter
            fellesareal i forespørsel, søkt, gitt i tilsagn eller utbetalt.
          </td>
        </tr>
        <tr>
          <td>Forespørsel</td>
          <td>
            Kommunene skal sende en forespørsel så tidlig som mulig i planleggings-/prosjekteringsfasen der de blant opplyser om behovet for sykehjemsplassene/omsorgsboligene.
            Viser statistikk for dette innenfor gitte søkekriterier.
          </td>
        </tr>
        <tr>
          <td>Søknad</td>
          <td>
            Etter at Husbanken og kommunen har blitt omforent om prosjektet kan det sendes inn en søknad om tilskudd. Viser statistikk for dette innenfor gitte søkekriterier.
          </td>
        </tr>
        <tr>
          <td>Tilsagn</td>
          <td>Tilsagn er et løfte om penger mot at søker oppfyller visse betingelser. Et tilsagn kan ha flere boliger. Det kan være flere tilsagn på en sak.</td>
        </tr>
        <tr>
          <td>Utbetalinger</td>
          <td>Viser statistikk for utbetalte tilskudd innenfor gitte søkekriterier. Tilskuddet utbetales når prosjektet er ferdigstilt og tatt i bruk.</td>
        </tr>
      </tbody>
    </table>
  }
</div>
